import React, { useContext } from 'react'
import { Route, Redirect } from 'react-router'
import { SessionContext } from 'data/context';

export const PrivateReports = ({ component: Component, dealers, dateRange, setDateRange, ...rest }) => {
  const auth = useContext(SessionContext).ftusertype.toString();
  
  return (
    <Route
      {...rest}
      render={props =>
        auth ? (
          <Component dealers={dealers} dateRange={dateRange} setDateRange={setDateRange} {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/'
            }}
          />
        )
      }
    />
  )
}
